// extracted by mini-css-extract-plugin
module.exports = {"header":"line-header_header__k4t__","span":"line-header_span__rH6S3"};